import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PersonaTipoUtenteEnum } from '../../../api/generated/apc/api';
import { GlobalActions } from '../../../model/global-actions';
import appRoutes from '../../../routing/app-routes';
import {
  setFiduciaria,
  setSelectedOptionUserType,
  startRegistrationFlow,
} from '../../../store/features/user-access/user-registration/user-registration-slice';
import { useAppSelector } from '../../redux';
import { TipoUtenteEnum } from '../../../model';

export interface UserRegistrationPageLogicCallbacks {
  selectedOptionUserType: TipoUtenteEnum;
  goAhead: () => void;
  onSelectedOptionChanged: (value: string) => void;
  buttonDisabled?: boolean;
}

export const useUserRegistrationPageLogic = (
  actions: GlobalActions
): UserRegistrationPageLogicCallbacks => {
  const { navigate } = actions;
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const dispatch = useDispatch();

  const { selectedOptionUserType, flowStarted, fiduciaria } = useAppSelector(
    (state) => state.features.userRegistration
  );

  /**
   * Must notify to the store that the registration process has started
   */
  useEffect(() => {
    if (!flowStarted) {
      dispatch(startRegistrationFlow());
    }
  }, [flowStarted, dispatch]);

  const onSelectedOptionChanged = useCallback(
    (option: string) => {
      if (option === TipoUtenteEnum.Fid) {
        dispatch(setSelectedOptionUserType('PG' as PersonaTipoUtenteEnum));
        dispatch(setFiduciaria(true));
      } else {
        dispatch(setSelectedOptionUserType(option as PersonaTipoUtenteEnum));
        dispatch(setFiduciaria(false));
      }
      setButtonDisabled(false);
    },
    [dispatch]
  );

  const goAhead = useCallback(() => {
    dispatch(setSelectedOptionUserType(selectedOptionUserType));
    navigate(appRoutes.InsertDataUserRegistration, { replace: false });
  }, [dispatch, navigate, selectedOptionUserType]);

  const userType = useMemo(() => {
    if (selectedOptionUserType === PersonaTipoUtenteEnum.Pg) {
      return fiduciaria ? TipoUtenteEnum.Fid : TipoUtenteEnum.Pg;
    } else {
      return TipoUtenteEnum.Pf;
    }
  }, [fiduciaria, selectedOptionUserType]);

  return {
    selectedOptionUserType: userType,
    goAhead,
    onSelectedOptionChanged,
    buttonDisabled,
  };
};
